module.exports = __webpack_public_path__ + "static/034-ebb4478746878010321f1542f1660a1c.jpg";